export const filterOptions = [
	{ name: 'None', value: 'none' },
	{ name: 'Vintage', value: 'contrast(90%) brightness(90%) sepia(30%)' },
	{ name: 'Warm Glow', value: 'brightness(110%) sepia(10%)' },
	{ name: 'Cool Breeze', value: 'hue-rotate(180deg) brightness(90%)' },
	{ name: 'Polaroid', value: 'contrast(120%) brightness(100%) sepia(20%) blur(1px)' },
	{ name: 'Neon Lights', value: 'brightness(120%) saturate(200%)' },
	{ name: 'Cinematic', value: 'contrast(120%) brightness(80%) blur(0.5px)' },
	{ name: 'Faded', value: 'brightness(80%) contrast(80%)' },
	{ name: 'Cross-Process', value: 'contrast(130%) hue-rotate(40deg)' },
	{ name: 'High Contrast', value: 'contrast(200%) brightness(90%)' },
	{ name: 'Grayscale', value: 'grayscale(100%)' },
	{ name: 'Sepia', value: 'sepia(100%)' },
	{ name: 'Invert', value: 'invert(100%)' },
	{ name: 'Hue Rotate 90°', value: 'hue-rotate(90deg)' },
	{ name: 'Hue Rotate 180°', value: 'hue-rotate(180deg)' },
	{ name: 'Hue Rotate 270°', value: 'hue-rotate(270deg)' },
	{ name: 'Blur', value: 'blur(2px)' },
	{ name: 'Contrast 200%', value: 'contrast(200%)' },
	{ name: 'Brightness 50%', value: 'brightness(50%)' }
];